import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { path: '/', name: 'Home' },
  { path: '/showcase', name: 'Showcase' },
  { path: '/cnc', name: 'CNC Services' },
  { path: '/glass-seals', name: 'Glass Seals' },
  { path: '/equipment', name: 'Equipment List' },
  { path: '/materials', name: 'Materials' },
  { path: '/workflow', name: 'Workflow' },
  { path: '/about', name: 'About Accratronics' },
  { path: '/contact', name: 'Contact Us' }
];

const NotFound = () => (
  <div className="hero is-light is-medium is-bold">
    <div className="hero-body">
      <div className="container ">
        <h1 className="title is-2">
          Sorry, this isn't the page you're looking for.
        </h1>
        <hr style={{ width: '30%' }} />
        <h2 className="subtitle is-4">
          We can't find anything at this URL.
        </h2>
        <h3 className="subtitle is-6">
          Try our{' '}
          <Link to="/" className="subtitle is-6 has-text-link">
            home page
          </Link>{' '}
          to find what you're looking for, or click one of the links below:
        </h3>
        <div className="columns">
          <div className="column is-narrow">
            <ul>
              {links.slice(0, 4).map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="has-text-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="column is-offset-1">
            <ul>
              {links.slice(4, 8).map(link => (
                <li key={link.name}>
                  <Link to={link.path} className="has-text-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Link to="/">
          <button className="button is-brand is-outlined is-medium">
            Click Here To Return Home
          </button>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound.js